import { convertToServiceInboxReminders } from '../actions/inboxRemindersActions';
import { mutator } from 'satcheljs';

mutator(convertToServiceInboxReminders, actionMessage => {
    const { newReminderIds, inboxReminders } = actionMessage;

    if (!inboxReminders) {
        // inboxReminders is undefined when the event is service event, i.e event opened through reading pane
        return;
    }

    for (let i = 0; i < inboxReminders.length; i++) {
        const reminder = inboxReminders[i];

        // For new inbox reminder, clear the GUID Id created by client. Otherwise CreateCalendarEvent service would fail with invalid data.
        if (newReminderIds.includes(reminder.Id)) {
            delete reminder['Id'];
        }
    }
});
